/**
 * Services Version Counter Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.servicesVersionCounterFormatter = function(value, row) {
    let html = '';
    if (value === null) {
        return html;
    }
    let data = JSON.parse(value);
    html += '<div class="d-flex justify-content-center">';
    html += '<div class="col text-center">';
    if (data.major !== 0) {
        html += '<span class="badge rounded-pill bg-danger mx-1">'+data.major+'</span>';
    }
    html += '</div>';
    html += '<div class="col text-center">';
    if (data.minor !== 0) {
        html += '<span class="badge rounded-pill bg-warning mx-1">'+data.minor+'</span>';
    }
    html += '</div>';
    html += '<div class="col text-center">';
    if (data.patch !== 0) {
        html += '<span class="badge rounded-pill bg-info mx-1">'+data.patch+'</span>';
    }
    html += '</div>';
    html += '</div>';
    return html;
};
